import { OverlayRef } from '@angular/cdk/overlay';
import { TemplateRef, Type } from '@angular/core';
import { DialogConfig } from '@app/dialog/models';
import { Subject } from 'rxjs';

export class DialogRef<R = any, T = any> {
  public afterClosed$: Subject<Nullable<R>> = new Subject();

  constructor(
    public overlay: OverlayRef,
    public content: string | TemplateRef<any> | Type<any>,
    public config?: DialogConfig<T>
  ) {}

  public close(data: Nullable<R> = null): void {
    this.overlay.detach();
    setTimeout(() => this.overlay.dispose(), 300);

    this.afterClosed$.next(data);
    this.afterClosed$.complete();
  }
}
